import { addDays, getISOWeek, getISOWeekYear, getISOWeeksInYear, startOfISOWeek } from "date-fns";

export const MONTHS_SHORT = ["gen", "feb", "mar", "apr", "mag", "giu", "lug", "ago", "set", "ott", "nov", "dic"];

export const shortDate = (d) => `${d.getDate()} ${MONTHS_SHORT[d.getMonth()]}`;

export function isoWeeks(year) {
  const anchor = new Date(year, 0, 4);
  const first = startOfISOWeek(anchor);
  const count = getISOWeeksInYear(anchor);
  return Array.from({ length: count }, (_, i) => {
    const start = addDays(first, i * 7);
    const end = addDays(start, 6);
    return { week: i + 1, start, end, label: `Settimana ${i + 1} (${shortDate(start)} - ${shortDate(end)})` };
  });
}

export const currentWeek = () => ({ year: getISOWeekYear(new Date()), week: getISOWeek(new Date()) });

export const fmtMin = (m) => `${Math.floor((m || 0) / 60)}:${String((m || 0) % 60).padStart(2, "0")}`;
